import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';

import { AuthenticationService } from '../_service/authentication.service';
import { AlertService } from '../_service/alert.service';

import { GlobalEventsService } from '../_service/globalevents.service';

@Component({
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.css'],
})

export class LoginComponent implements OnInit {
    @Output() loggedIn: EventEmitter<any> = new EventEmitter();

    model: any = {};
    loading = false;
    error = '';

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService,
        private alertService: AlertService,
        private globalEventsService: GlobalEventsService) {
    }

    ngOnInit() {
        // reset login status
        this.authenticationService.logout();
    }

    login() {
        this.loading = true;
        this.authenticationService.login(this.model.email, this.model.password)
            .subscribe(
                data => {
                    this.globalEventsService.showIsLoggedIn(true);
                    this.router.navigate(['/']);
                },
                error => {
                    this.alertService.error('Username or password invalid');
                    // this.alertService.error(error);
                    this.loading = false;
                });
    }
}
